import React from 'react';
import { Pane, Heading, Paragraph, Icon } from 'evergreen-ui';

const EmptyContent = ({ noResults = false }) => (
  <Pane textAlign="center" marginTop={40} marginLeft="auto" marginRight="auto">
    <Icon icon="th-derived" size={24} color="muted" />
    <Heading marginTop={8}>No results returned</Heading>
    <Paragraph color="muted">
      Please refine your query or create a new entry
    </Paragraph>
  </Pane>
);

export default EmptyContent;
